import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import SubscriptionHistory from './subscription-history';
import SubscriptionHistoryDetail from './subscription-history-detail';
import SubscriptionHistoryUpdate from './subscription-history-update';
import SubscriptionHistoryDeleteDialog from './subscription-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SubscriptionHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SubscriptionHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SubscriptionHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={SubscriptionHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={SubscriptionHistoryDeleteDialog} />
  </>
);

export default Routes;
